import styles from '../../payment-form/payment-form.module.scss';
import Input from '../../input/input';

type Props = {
    onInput: (value: string) => void;
    error?: string;
};

const CasheaForm = ({ onInput, error }: Props) => (
    <form className={styles.paymentForm}>
        <div className={styles.info}>
            <span>¿Realizaste la compra en Cashea?</span>
            <span style={{ textAlign: 'center' }}>
                Puedes registrar tu pago aquí para que nuestro equipo lo
                verifique lo antes posible y activar tu suscripción
            </span>
        </div>
        <Input
            placeholder={'Número de compra en Cashea'}
            onInput={onInput}
            error={error}
        />
    </form>
);

export { CasheaForm };
